import React from 'react';
import Modal from 'ui-v2/components/Modal';
import { OverlayLoader } from "core-lib/components/OverlayLoader/OverlayLoader";

type StoreLoaderPropType = {
  show: boolean;
};
export const StoreLoader = ({ show }: StoreLoaderPropType) => {
  return (
    <Modal
      show={show}
      head={{
        show: false,
      }}
      variant="page"
      rootStyle={{
        zIndex: '5',
        background: 'transparent',
      }}
      customeBodyStyle={{
        background: 'transparent',
      }}
    >
      <OverlayLoader
        show={show}
        styleProp={{
          zIndex: 10,
          height: '100vh',
        }}
      />
    </Modal>
  );
};
